// ============================================================
// CAPTAIN BLACKSKULL'S — THEME JS
// ============================================================

document.addEventListener('DOMContentLoaded', function () {

  // Cart count update without full reload (basic AJAX add-to-cart)
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Let default Shopify behaviour handle it, but flash the cart button
      const cartBtn = document.querySelector('.bs-cart-btn');
      if (cartBtn) {
        cartBtn.style.boxShadow = '0 0 18px rgba(0,255,157,0.9)';
        setTimeout(function () {
          cartBtn.style.boxShadow = '';
        }, 400);
      }
    });
  });

});
